export default __webpack_public_path__ + "f3f4f11473ab67b958f451ac38902390.svg";